// extracted by css-extract-rspack-plugin
export default {"head":"head-MvYIAT","channel":"channel-zXrhzR"};